import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Button from 'components/common/Button/Button'
import { Input } from 'components/common/FormElements/Input'
import { Form } from 'redux-form'
import { Instructions, Field } from '../components/Recovery/ForgotPages.styles'

const ForgotPasswordWrapper = ({
  form,
  instructions,
  description,
  submitting,
  submitSucceeded,
  handleHide,
  handleSubmit
}) =>
  <Form data-at-forgotpasswordmodal noValidate onSubmit={ handleSubmit }>
    {
      submitSucceeded ?
        <React.Fragment>
          <Instructions data-at-instructions>{ description }</Instructions>
        </React.Fragment> :
        <React.Fragment>
          <Instructions data-at-instructions>{ instructions }</Instructions>
          <FieldWrapper>
            <Field { ...form.email } full="mobile" component={ Input } />
          </FieldWrapper>
          <Button data-at-forgotpasswordmodal-send stacked="mobile" narrow full="mobile" disabled={ submitting }>Send</Button>
          <Button data-at-forgotpasswordmodal-cancel stacked="mobile" narrow full="mobile" link bolder type="button" onClick={ handleHide }>Cancel</Button>
        </React.Fragment>
    }
  </Form>

ForgotPasswordWrapper.propTypes = {
  description: PropTypes.string,
  email: PropTypes.string,
  error: PropTypes.string,
  form: PropTypes.shape({
    email: PropTypes.shape()
  }),
  handleHide: PropTypes.func,
  handleSubmit: PropTypes.func,
  instructions: PropTypes.string,
  submit: PropTypes.func,
  submitSucceeded: PropTypes.bool,
  submitting: PropTypes.bool
}

export default ForgotPasswordWrapper

const FieldWrapper = styled.div`
  margin-bottom: 8px;
`
